import { getOrCreateHiddenInput } from '../../templates/components/checkout/utils/getOrCreateHiddenInput';
import { decodeHtml } from '../../templates/components/customers/helpers/helpers';

export type AttachedServices = { [key: string]: { sku: string; price: string } };
export const ATTACHED_SERVICES_STORAGE_KEY = 'attachedServices';
export const ATTACHED_SERVICES_HIDDEN_FORM_FIELD = `checkout[attributes][${ATTACHED_SERVICES_STORAGE_KEY}]`;

export const removeLinkedService = (serviceLink: string, attachedServices: AttachedServices): AttachedServices => {
  const { [serviceLink]: _, ...rest } = attachedServices;
  return rest;
};

export const removeAttachedService = (serviceLink: string): void => {
  const updatedBasketAttachedServices = removeLinkedService(serviceLink, getAttachedServices());
  setAttachedServices(updatedBasketAttachedServices);
};

const isOrderConfirmationView = () => {
  return window.Shopify?.Checkout?.step === 'thank_you' || window.Shopify?.Checkout?.isOrderStatusPage;
};

const parseAttachedServiceString = (value: string): AttachedServices => {
  try {
    return JSON.parse(value);
  } catch (e) {
    console.log('Error parsing attached services', e);
    return {};
  }
};

export const getAttachedServices = (): AttachedServices => {
  if (isOrderConfirmationView()) {
    const rawCartAttributeAttachedServices = window.cart?.attributes[ATTACHED_SERVICES_STORAGE_KEY];
    if (rawCartAttributeAttachedServices) {
      return parseAttachedServiceString(decodeHtml(rawCartAttributeAttachedServices));
    }
    return {};
  }

  const cartAttachedServices = window.localStorage.getItem(ATTACHED_SERVICES_STORAGE_KEY);
  if (cartAttachedServices && cartAttachedServices !== '{}') {
    return parseAttachedServiceString(cartAttachedServices);
  }
  return {};
};

export const setAttachedServices = (attachedServices: AttachedServices) => {
  window.localStorage.setItem(ATTACHED_SERVICES_STORAGE_KEY, JSON.stringify(attachedServices));
};

export const cleanupAttachedServices = (): void => {
  window.localStorage.removeItem(ATTACHED_SERVICES_STORAGE_KEY);
};

export const updateAttachedServicesFormValues = (orderForm: Element) => {
  const attachedServices = getAttachedServices();
  if (Object.keys(attachedServices).length) {
    const hiddenAttachedServices = getOrCreateHiddenInput(orderForm, ATTACHED_SERVICES_HIDDEN_FORM_FIELD);
    hiddenAttachedServices.value = JSON.stringify(attachedServices);
  }
};
